<template>
  <div class="message-area">
    <div class="message-area-label p-3 border-bottom">
      <h5 class="mb-0">{{ chatTitle }}</h5>
      <span class="close-button" v-if="isMobile" @click="handleClose">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#0F1729"/>
        </svg>
      </span>
    </div>
    <div ref="messagesContainer" class="messages-container">
      <div
        v-for="message in messages"
        :id="'tg_id_'+message.message_tg_id"
        :key="message.id"
        :class="['message-bubble', {
          'message-outgoing': message.senderId == currentUser.id,
          'message-incoming': message.senderId != currentUser.id
        }]"
      >
        <div
          class="message-reply"
          v-if="message.reply_to_tg_id"
          @click="clickToReplyMessage(message.reply_to_tg_id)"
        >
          {{ message.reply_message }}
        </div>
        <div class="message-content" v-html="message.text"></div>
        <div class="message-time">
          {{ message.senderName }} |
          {{ formatMessageTime(message.timestamp) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch, nextTick } from 'vue'

export default {
  name: 'MessageArea',
  props: {
    chatTitle: {
      type: String,
      required: true
    },
    messages: {
      type: Array,
      required: true
    },
    currentUser: {
      type: Object,
      required: true
    },
    isMobile: {
      type: Boolean,
    },
  },
  emits: ['close-chat'],
  setup(props, { emit }) {
    const messagesContainer = ref(null)

    const formatMessageTime = (timestamp) => {
      return new Date(timestamp * 1000).toLocaleTimeString('ru-RU', {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: '2-digit',
        minute: '2-digit'
      })
    }

    // Автопрокрутка к новым сообщениям
    const scrollToBottom = () => {
      if (messagesContainer.value) {
        nextTick(() => {
          messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight
        })
      }
    }

    const clickToReplyMessage = (tgId) => {
      const el = document.getElementById('tg_id_'+tgId)
      if (el) el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }

    const handleClose = () => {
      emit('close-chat')
    }

    watch(() => props.messages, () => {
      scrollToBottom()
    }, { deep: true })

    return {
      messagesContainer,
      clickToReplyMessage,
      formatMessageTime,
      handleClose,
    }
  }
}
</script>

<style scoped>
.message-area {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 100%;
  margin-bottom: 70px;
}

.message-area-label {
  position: relative;
}

.message-area-label .close-button {
  position: absolute;
  right: 16px;
  top: 16px;
}

.message-area-label .close-button svg {
  width: 24px;
}

.messages-container {
  flex-grow: 1;
  overflow-y: auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.message-bubble {
  max-width: 70%;
  padding: 0.75rem 1rem;
  border-radius: 1rem;
  position: relative;
}

.message-incoming {
  align-self: flex-start;
  background-color: #f1f3f5;
  border-bottom-left-radius: 0.25rem;
}

.message-outgoing {
  align-self: flex-end;
  background-color: #007bff;
  color: white !important;
  border-bottom-right-radius: 0.25rem;
}
:deep(.message-outgoing) a {
  color: lightblue;
}
:deep(.message-outgoing) a:hover {
  color: white;
}

.message-reply {
  border-left: 5px solid lightslategray;
  font-size: 0.8em;
  padding: 3px;
  color: lightslategray;
  cursor: pointer;
}

.message-content {
  margin-bottom: 0.25rem;
  word-wrap: break-word;
}

.message-time {
  font-size: 0.7rem;
  opacity: 0.7;
  text-align: right;
}
</style>
